import { cx } from "@emotion/css";
import ReactTooltip from "react-tooltip";
import { TextBody } from "../DesignSystem/DesignSystemText";

const Tooltip = ({ id, children, className, disable }: any) => {
  return (
    <>
      <ReactTooltip
        id={id}
        className={cx(className, "!rounded max-w-[252rem] !px-4 !py-3")}
        effect="solid"
        disable={disable}
      >
        <TextBody className="!text-white !text-[14rem] text-center">
          {children}
        </TextBody>
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
